import {getField, updateField} from 'vuex-map-fields';
import BaseTableModule from '@/commonFunction/baseTableModule'

let bom = new BaseTableModule('/ws/bom/');

const state = {
    ...bom.state,
    columns: [
        // {text: 'Actions', value: 'actions', sortable: false, divider: true, brief: true,},
        // {text: 'ID', value: 'id', sortable: true, filterable: true, divider: true, brief: true,},
        {text: 'Name', value: 'name', sortable: true, filterable: true, divider: true, brief: true,},
        {text: 'Created by', value: 'created_by', sortable: true, divider: true, brief: true,},
        {text: 'Created on', value: 'created_on', sortable: true, divider: true, brief: true,},
        {text: 'Edited by', value: 'edited_by', sortable: true, divider: true, brief: true,},
        {text: 'Edited on', value: 'edited_on', sortable: true, divider: true, brief: true,},
    ],
    briefView: true,
    options: {
        page: 1,
        itemsPerPage: 250,
        sortBy: ['-id'],
        sortDesc: [false],
        multiSort: false,
        mustSort: true,
        descending: true,
    },

};
const getters = {
    ...bom.getters,
    getColumns(state) {
        if (state.briefView) {
            return state.columns.filter(row => row.brief === true)
        } else {
            return state.columns
        }
    },
};
const actions = {
    ...bom.actions,
};
const mutations = {
    ...bom.mutations,
};

export default {
    modules: {
        Bom: {
            namespaced: true,
            state,
            getters,
            actions,
            mutations
        }
    }
}